import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import uuid from "react-uuid";
import { userAssocData } from "app/utils/utils";
import md5 from "md5";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
import cloneDeep from "lodash.clonedeep";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  usersList: [],
  rolesList: [],
  dashboardUserRoleList: {
    advertiser: [],
    bidder: [],
    publisher: [],
  },
  userFlag: false,
  userDetails: {
    id: "",
    name: "",
    email: "",
    username: "",
    password: "",
    retypePassword: "",
    company: "",
    accounts: "",
    publishers: "",
    roleId: "",
    advCompany: "",
    advAccounts: "",
    advertisers: "",
    bidCompany: "",
    bidAccounts: "",
    bidders: "",
    singleSignonCode: "",
    reference_user_id: "",
    geointel_enabled: "0",
  },
  userFilters: {
    organizations: [],
  },
  userFilterFormValues: {
    organizations: [],
  },
  transferUserList: [],
};

export const GetAllUsersListThunk = createAsyncThunk(
  "user/GetAllUsersListThunk",
  async (payload) => {
    let authUserData = payload?.authUserData;
    var userFilters = payload?.userFilters;
    let whereConditions = [];

    let query = "";
    if (userFilters?.organizations.length > 0) {
      whereConditions.push(
        ` u.id !='${authUserData.user_id}' and u.is_active in ('1','0') and is_sys_admin !='1' `
      );

      whereConditions.push(
        "assn.companyid IN ('" + userFilters?.organizations.join("','") + "')"
      );

      if (authUserData.is_sys_admin == "0") {
        whereConditions.push(` u.reference_user_id='${authUserData.user_id}' `);
      }
      if (
        payload?.search != "" &&
        payload?.search != undefined &&
        payload?.search != null
      ) {
        whereConditions.push(
          ` u.name ${DATASOURCE_CONFIG.QUERY_LIKE} '%${payload.search}%' `
        );
      }
      let whereString =
        whereConditions.length > 0
          ? " where " + whereConditions.join(" and ")
          : "";

      // query=`SELECT u.id,u.name,u.email,u.username,r.name AS role_name,u.creation_date,u.last_login,
      // u.is_active,u.single_signon_code AS sscode  FROM users AS u JOIN user_assoc AS assn ON u.id=assn.id  LEFT JOIN user_roles AS r ON u.role_id=r.id
      // WHERE  u.id !='${authUserData.user_id}'
      // AND u.is_active IN ('1','0') AND is_sys_admin !='1' AND assn.companyid=u.id  ORDER BY u.creation_date DESC`
      query = `SELECT u.id,u.name,u.email,u.username,r.name AS role_name,u.creation_date,u.last_login,u.is_active,u.single_signon_code AS sscode  FROM ${tablePrefix} users AS u  JOIN ${tablePrefix} user_assoc AS assn ON u.id = assn.id  LEFT JOIN ${tablePrefix} user_roles AS r ON u.role_id = r.id  ${whereString} ORDER BY u.creation_date DESC`;
    } else {
      whereConditions.push(
        ` u.id !='${authUserData.user_id}' and u.is_active in ('1','0') and is_sys_admin !='1' `
      );

      if (authUserData.is_sys_admin == "0") {
        whereConditions.push(` u.reference_user_id='${authUserData.user_id}' `);
      }
      if (
        payload?.search != "" &&
        payload?.search != undefined &&
        payload?.search != null
      ) {
        whereConditions.push(
          ` u.name ${DATASOURCE_CONFIG.QUERY_LIKE} '%${payload.search}%' `
        );
      }
      let whereString =
        whereConditions.length > 0
          ? " where " + whereConditions.join(" and ")
          : "";
      query = `select u.id,u.name,u.email,u.username,r.name as role_name,u.creation_date,u.last_login,u.is_active,u.single_signon_code as sscode  from ${tablePrefix}users as u left join ${tablePrefix}user_roles as r on u.role_id=r.id ${whereString} order by u.creation_date desc`;
    }

    const queryBody = {
      queries: [
        {
          query: query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdateUserDetailsThunk = createAsyncThunk(
  "user/InsertUpdateUserDetailsThunk",
  async (payload) => {
    //console.log('payload', payload)
    let authUserData = payload?.authUserData;
    let insertUpdateQuery = "";
    let insertUpdateUserAssocQuery = "";

    let insertDashboardUserRoleQuery = "";
    let insertBidDashboardUserRoleQuery = "";
    let insertPubDashboardUserRoleQuery = "";
    let deleteDashboardUserRoleQuery = "";
    let deleteBidDashboardUserRoleQuery = "";
    let deletePubDashboardUserRoleQuery = "";
    let queriesArr = [];

    console.log("payloadData:", payload);
    // return false;

    //check pubadmin /adv admin
    let is_pub_admin = 0;
    let is_adv_admin = 0;
    let is_bidder_admin = 0;
    if (
      payload?.publishers?.length <= 0 &&
      (payload?.accounts?.length > 0 ||
        (payload?.company != "" &&
          payload?.company != null &&
          payload?.company != undefined))
    ) {
      is_pub_admin = 1;
    }

    if (
      payload?.advertisers?.length <= 0 &&
      (payload?.advAccounts?.length > 0 ||
        (payload?.advCompany != "" &&
          payload?.advCompany != null &&
          payload?.advCompany != undefined))
    ) {
      is_adv_admin = 1;
    }

    if (
      payload?.bidders?.length <= 0 &&
      (payload?.bidAccounts?.length > 0 ||
        (payload?.bidCompany != "" &&
          payload?.bidCompany != null &&
          payload?.bidCompany != undefined))
    ) {
      is_bidder_admin = 1;
    }

    if (
      payload.supply_dashboard_enabled == "1" ||
      payload.dashboard_enabled == "1"
    ) {
      insertDashboardUserRoleQuery =
        "insert into dashboard_userid_userrole_assoc (userid_userrole_assoc_id,user_id,user_role_id,profile) values('" +
        uuid() +
        "','" +
        payload.id +
        "','" +
        payload.adv_dashboard_user_role_id +
        "','advertiser')";
      if (payload.bid_dashboard_user_role_id != "") {
        insertBidDashboardUserRoleQuery =
          "insert into dashboard_userid_userrole_assoc (userid_userrole_assoc_id,user_id,user_role_id,profile) values('" +
          uuid() +
          "','" +
          payload.id +
          "','" +
          payload.bid_dashboard_user_role_id +
          "','bidder')";
      }

      if (payload.pub_dashboard_user_role_id != "") {
        insertPubDashboardUserRoleQuery =
          "insert into dashboard_userid_userrole_assoc (userid_userrole_assoc_id,user_id,user_role_id,profile) values('" +
          uuid() +
          "','" +
          payload.id +
          "','" +
          payload.pub_dashboard_user_role_id +
          "','publisher')";
      }
    }

    const canManageGeoIntel = String(authUserData?.is_sys_admin) === "1";

    if (payload.action == "add") {
      let id = payload.id;
      let assocData = userAssocData(payload, id);

      const insertColumns = [
        "id",
        "name",
        "email",
        "username",
        "reference_user_id",
        "password",
        "creation_date",
        "last_login",
        "role_id",
        "is_adv_admin",
        "is_pub_admin",
        "is_bidder_admin",
        "created_by",
        "dashboard_enabled",
        "dashboard_max_days",
        "supply_dashboard_enabled",
        "supply_dashboard_max_days",
        "supply_dashboard_accounts",
        "supply_dashboard_show_prices",
        "supply_dashboard_price_percentage",
        "single_signon_code",
      ];
      const insertValues = [
        "'" + id + "'",
        "'" + addslashes(payload.name) + "'",
        "'" + addslashes(payload.email) + "'",
        "'" + addslashes(payload.username) + "'",
        "'" + payload.reference_user_id + "'",
        "'" + md5(payload.password) + "'",
        DATASOURCE_CONFIG.CURRENT_DATE,
        DATASOURCE_CONFIG.CURRENT_DATE,
        "'" + payload.roleId + "'",
        "'" + is_adv_admin + "'",
        "'" + is_pub_admin + "'",
        "'" + is_bidder_admin + "'",
        "'" + authUserData.user_id + "'",
        "'" + payload.dashboard_enabled + "'",
        "'" + payload.dashboard_max_days + "'",
        "'" + payload.supply_dashboard_enabled + "'",
        "'" + payload.supply_dashboard_max_days + "'",
        "'" + payload.supply_dashboard_accounts + "'",
        "'" + payload.supply_dashboard_show_prices + "'",
        "'" + payload.supply_dashboard_price_percentage + "'",
        "'" + payload.single_signon_code + "'",
      ];

      if (canManageGeoIntel) {
        insertColumns.push("geointel_enabled");
        insertValues.push("'" + payload.geointel_enabled + "'");
      }

      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "users (" +
        insertColumns.join(",") +
        ") values(" +
        insertValues.join(",") +
        ") ";

      insertUpdateUserAssocQuery =
        "insert into " +
        tablePrefix +
        "user_assoc (id,profile,profileid,accountid,companyid) values " +
        assocData.join(",") +
        " ";
      queriesArr = [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: insertUpdateUserAssocQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];
      if (
        insertDashboardUserRoleQuery != "" &&
        insertDashboardUserRoleQuery != null
      ) {
        queriesArr.push({
          query: insertDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      if (
        insertBidDashboardUserRoleQuery != "" &&
        insertBidDashboardUserRoleQuery != null
      ) {
        queriesArr.push({
          query: insertBidDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      if (
        insertPubDashboardUserRoleQuery != "" &&
        insertPubDashboardUserRoleQuery != null
      ) {
        queriesArr.push({
          query: insertPubDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    } else {
      const updateAssignments = [
        "name='" + addslashes(payload.name) + "'",
        "username='" + addslashes(payload.username) + "'",
        "is_adv_admin='" + is_adv_admin + "'",
        "is_pub_admin='" + is_pub_admin + "'",
        "role_id='" + payload.roleId + "'",
        "is_bidder_admin='" + is_bidder_admin + "'",
        "dashboard_enabled='" + payload.dashboard_enabled + "'",
        "dashboard_max_days='" + payload.dashboard_max_days + "'",
        "supply_dashboard_enabled='" + payload.supply_dashboard_enabled + "'",
        "supply_dashboard_max_days='" + payload.supply_dashboard_max_days + "'",
        "supply_dashboard_accounts='" + payload.supply_dashboard_accounts + "'",
        "supply_dashboard_show_prices='" +
          payload.supply_dashboard_show_prices +
          "'",
        "supply_dashboard_price_percentage='" +
          payload.supply_dashboard_price_percentage +
          "'",
        "single_signon_code='" + payload.single_signon_code + "'",
        "reference_user_id='" + payload.reference_user_id + "'",
      ];

      if (canManageGeoIntel) {
        updateAssignments.push(
          "geointel_enabled='" + payload.geointel_enabled + "'"
        );
      }

      insertUpdateQuery =
        "update " +
        tablePrefix +
        "users set " +
        updateAssignments.join(",") +
        " where id='" +
        payload.id +
        "'";
      let assocData = userAssocData(payload, payload.id);
      console.log("assocData", assocData);
      let deleteUserAssocQuery =
        "delete from " +
        tablePrefix +
        "user_assoc where id='" +
        payload.id +
        "'";

      insertUpdateUserAssocQuery =
        "insert into " +
        tablePrefix +
        "user_assoc (id,profile,profileid,accountid,companyid) values " +
        assocData.join(",") +
        " ";
      deleteDashboardUserRoleQuery =
        "DELETE from " +
        tablePrefix +
        " dashboard_userid_userrole_assoc where user_id='" +
        payload.id +
        "' and profile='advertiser'";
      deleteBidDashboardUserRoleQuery =
        "DELETE from " +
        tablePrefix +
        " dashboard_userid_userrole_assoc where user_id='" +
        payload.id +
        "' and profile='bidder'";
      deletePubDashboardUserRoleQuery =
        "DELETE from " +
        tablePrefix +
        " dashboard_userid_userrole_assoc where user_id='" +
        payload.id +
        "' and profile='publisher'";

      queriesArr = [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: deleteUserAssocQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: insertUpdateUserAssocQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: deleteDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: deleteBidDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: deletePubDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];
      if (
        insertDashboardUserRoleQuery != "" &&
        insertDashboardUserRoleQuery != null
      ) {
        queriesArr.push({
          query: insertDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      if (
        insertBidDashboardUserRoleQuery != "" &&
        insertBidDashboardUserRoleQuery != null
      ) {
        queriesArr.push({
          query: insertBidDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      if (
        insertPubDashboardUserRoleQuery != "" &&
        insertPubDashboardUserRoleQuery != null
      ) {
        queriesArr.push({
          query: insertPubDashboardUserRoleQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }

    const queryBody = {
      queries: queriesArr,
    };
    console.log("queriesArr", queriesArr);
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      console.log("response", err);
      return (
        err?.response || {
          data: {
            error: true,
            message: err?.message || "Something went wrong!",
            results: null,
          },
        }
      );
    }
  }
);

export const GetUserDetailsThunk = createAsyncThunk(
  "user/GetUserDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,username,email,password,role_id,supply_dashboard_enabled,dashboard_enabled,dashboard_max_days,supply_dashboard_max_days,supply_dashboard_accounts,supply_dashboard_show_prices,supply_dashboard_price_percentage,single_signon_code,reference_user_id,geointel_enabled from " +
            tablePrefix +
            "users where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select id,profile,profileid,accountid,companyid from " +
            tablePrefix +
            "user_assoc where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select user_role_id,profile from " +
            tablePrefix +
            "dashboard_userid_userrole_assoc where user_id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetRolesListThunk = createAsyncThunk(
  "user/GetRolesListThunk",
  async (payload) => {
    let companyIdCondition =
      payload.companyid != ""
        ? " where companyid='" + payload.companyid + "'"
        : "";
    const queryBody = {
      queries: [
        {
          query:
            "select id as value,name as label,user_permissions from " +
            tablePrefix +
            "user_roles " +
            companyIdCondition,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select user_role_id as value ,user_role_name as label,profile from " +
            tablePrefix +
            "dashboard_user_roles where  is_deleted=0",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "Select id as value,username,name as label from users where (is_bidder_admin=1 OR is_adv_admin=1 OR is_pub_admin=1) OR (is_sys_admin=1);",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const CheckUserNameExists = createAsyncThunk(
  "user/CheckUserNameExists",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select username from " +
            tablePrefix +
            "users where LOWER(username)='" +
            payload?.username?.toLowerCase() +
            "' and is_active='1'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateUserStatusThunk = createAsyncThunk(
  "user/UpdateUserStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "users set is_active='" +
            payload.status +
            "' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getDashboardUserRoleInfo = createAsyncThunk(
  "user/getDashboardUserRoleInfo",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, payload);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const User = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUserForm(state, action) {
      state.userDetails = {
        id: "",
        name: "",
        email: "",
        username: "",
        password: "",
        retypePassword: "",
        company: "",
        accounts: "",
        publishers: "",
        roleId: "",
        advCompany: "",
        advAccounts: "",
        advertisers: "",
        singleSignonCode: "",
        reference_user_id: "",
        geointel_enabled: "0",
      };
    },
    updateUserFiltersFormValues(state, action) {
      let userFilters = cloneDeep(state.userFilterFormValues);
      if (action.payload?.action == "delete") {
        userFilters = {
          organizations: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        userFilters[type] = data;
      }

      state.userFilterFormValues = userFilters;
    },
    updateUserFilters(state, action) {
      let userFilters = cloneDeep(state.userFilters);
      userFilters.organizations = action.payload.organizations;
      state.userFilters = userFilters;
    },
    updateUserFiltersFormValues(state, action) {
      let userFilters = cloneDeep(state.userFilterFormValues);
      if (action.payload?.action == "delete") {
        userFilters = {
          organizations: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        userFilters[type] = data;
      }

      state.userFilterFormValues = userFilters;
    },
    updateUserFilters(state, action) {
      let userFilters = cloneDeep(state.userFilters);
      userFilters.organizations = action.payload.organizations;
      state.userFilters = userFilters;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllUsersListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllUsersListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.usersList = action.payload.data.results[0];
        }
        // if (action.payload.data.status === 1) {
        // } else if (action.payload.data.status == 0) {
        //     // toast.error(action.payload.data.message);
        // }
        // if (state.globalAccountsList.length > 0) {
        //     state.globalAccount = state.globalAccountsList[0].value;
        //     console.log("state.globalAccount", state.globalAccount);
        // }
        state.loading = false;
      })
      .addCase(GetAllUsersListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(InsertUpdateUserDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(InsertUpdateUserDetailsThunk.fulfilled, (state, action) => {
        if (!action.payload.data?.error) {
          let accountArr = [];
          let company = "";
          let publisherArr = [];
          let advCompany = "";
          let advAccountArr = [];
          let advertiserArr = [];

          let bidCompany = "";
          let bidAccountArr = [];
          let bidderArr = [];

          let companyObj = action.meta.arg.company;
          let role_id = action.meta.arg.roleId;
          //let roleObj = action.meta.arg.roleId;
          if (
            companyObj != "" &&
            companyObj != null &&
            companyObj != undefined
          ) {
            company = companyObj.value;
          }

          if (action.meta.arg.accounts.length > 0) {
            let accountList = action.meta.arg.accounts;
            accountList.map((info) => {
              accountArr.push(info.value);
            });
          }
          if (action.meta.arg.publishers.length > 0) {
            let publisherList = action.meta.arg.publishers;
            publisherList.map((info) => {
              publisherArr.push(info.value);
            });
          }

          let advCompanyObj = action.meta.arg.advCompany;
          if (
            advCompanyObj != "" &&
            advCompanyObj != null &&
            advCompanyObj != undefined
          ) {
            advCompany = advCompanyObj.value;
          }

          if (action.meta.arg.advAccounts.length > 0) {
            let advaccountList = action.meta.arg.advAccounts;
            advaccountList.map((info) => {
              advAccountArr.push(info.value);
            });
          }
          if (action.meta.arg.advertisers.length > 0) {
            let advetisterList = action.meta.arg.advertisers;
            advetisterList.map((info) => {
              advertiserArr.push(info.value);
            });
          }

          let bidCompanyObj = action.meta.arg.bidCompany;
          if (
            bidCompanyObj != "" &&
            bidCompanyObj != null &&
            bidCompanyObj != undefined
          ) {
            bidCompany = bidCompanyObj.value;
          }

          if (action.meta.arg.bidAccounts.length > 0) {
            let bidaccountList = action.meta.arg.bidAccounts;
            bidaccountList.map((info) => {
              bidAccountArr.push(info.value);
            });
          }
          if (action.meta.arg.bidders.length > 0) {
            let bidderList = action.meta.arg.bidders;
            bidderList.map((info) => {
              bidderArr.push(info.value);
            });
          }

          // if (roleObj != "") {
          //   role_id = roleObj.value;
          // }

          let userData = {
            id: "",
            name: action.meta.arg.name,
            username: action.meta.arg.username,
            email: action.meta.arg.email,
            password: action.meta.arg.password,
            retypePassword: action.meta.arg.password,
            accounts: accountArr,
            company: company,
            publishers: publisherArr,
            roleId: role_id,
            advCompany: advCompany,
            advAccounts: advAccountArr,
            advertisers: advertiserArr,

            bidCompany: bidCompany,
            bidAccounts: bidAccountArr,
            bidders: bidderArr,

            advDashboardUserRoleId:
              action.meta.arg.dashboard_enabled == "1" ||
              action.meta.arg.supply_dashboard_enabled == "1"
                ? action.meta.arg.adv_dashboard_user_role_id
                : "",
            bidDashboardUserRoleId:
              action.meta.arg.dashboard_enabled == "1" ||
              action.meta.arg.supply_dashboard_enabled == "1"
                ? action.meta.arg.bid_dashboard_user_role_id
                : "",
            pubDashboardUserRoleId:
              action.meta.arg.dashboard_enabled == "1" ||
              action.meta.arg.supply_dashboard_enabled == "1"
                ? action.meta.arg.pub_dashboard_user_role_id
                : "",

            dashboard_enabled: action.meta.arg.dashboard_enabled,
            dashboard_max_days: action.meta.arg.dashboard_max_days,
            supply_dashboard_enabled: action.meta.arg.supply_dashboard_enabled,
            supply_dashboard_max_days:
              action.meta.arg.supply_dashboard_max_days,
            supply_dashboard_accounts:
              action.meta.arg.supply_dashboard_accounts,
            supply_dashboard_show_prices:
              action.meta.arg.supply_dashboard_show_prices,
            supply_dashboard_price_percentage:
              action.meta.arg.supply_dashboard_price_percentage,
            singleSignonCode: action.meta.arg.single_signon_code,
            geointel_enabled: action.meta.arg.geointel_enabled,
          };
          state.userDetails = userData;
        }
        state.loading = false;
      })
      .addCase(InsertUpdateUserDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetUserDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetUserDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let resultData = action.payload.data?.results[0][0];
          let userAssocData = action.payload.data?.results[1];
          //console.log('dfd', userAssocData)
          let accountArr = [];
          let company = "";
          let publisherArr = [];
          let advCompany = "";
          let advAccount = [];
          let advertiserArr = [];
          let bidCompany = "";
          let bidAccount = [];
          let biddersArr = [];
          userAssocData.map((info) => {
            if (
              info.hasOwnProperty("companyid") &&
              info.companyid != "-1" &&
              info.profile == "publisher"
            ) {
              company = info.companyid;
            }
            if (
              info.hasOwnProperty("accountid") &&
              info.accountid != "-1" &&
              info.profile == "publisher"
            ) {
              accountArr.push(info.accountid);
            }
            if (
              info.hasOwnProperty("profileid") &&
              info.profileid != "-1" &&
              info.profile == "publisher"
            ) {
              publisherArr.push(info.profileid);
            }

            if (
              info.hasOwnProperty("companyid") &&
              info.companyid != "-1" &&
              info.profile == "advertiser"
            ) {
              advCompany = info.companyid;
            }
            if (
              info.hasOwnProperty("accountid") &&
              info.accountid != "-1" &&
              info.profile == "advertiser"
            ) {
              advAccount.push(info.accountid);
            }
            if (
              info.hasOwnProperty("profileid") &&
              info.profileid != "-1" &&
              info.profile == "advertiser"
            ) {
              advertiserArr.push(info.profileid);
            }

            if (
              info.hasOwnProperty("companyid") &&
              info.companyid != "-1" &&
              info.profile == "bidder"
            ) {
              bidCompany = info.companyid;
            }
            if (
              info.hasOwnProperty("accountid") &&
              info.accountid != "-1" &&
              info.profile == "bidder"
            ) {
              bidAccount.push(info.accountid);
            }
            if (
              info.hasOwnProperty("profileid") &&
              info.profileid != "-1" &&
              info.profile == "bidder"
            ) {
              biddersArr.push(info.profileid);
            }
          });

          let advDashUserRoleId = "";
          let bidDashUserRoleId = "";
          let pubDashUserRoleId = "";
          let dashUserRoleIdResults = action.payload.data?.results[2];

          dashUserRoleIdResults.map((info) => {
            if (info.profile == "advertiser") {
              advDashUserRoleId = info.user_role_id;
            } else if (info.profile == "bidder") {
              bidDashUserRoleId = info.user_role_id;
            } else if (info.profile == "publisher") {
              pubDashUserRoleId = info.user_role_id;
            }
          });

          let userData = {
            id: resultData.id,
            name: resultData.name,
            username: resultData.username,
            email: resultData.email,
            password: resultData.password,
            retypePassword: resultData.password,
            company: company,
            accounts: accountArr,
            publishers: publisherArr,
            advCompany: advCompany,
            advAccounts: advAccount,
            advertisers: advertiserArr,
            roleId: resultData.role_id,
            bidCompany: bidCompany,
            bidAccounts: bidAccount,
            bidders: biddersArr,
            advDashboardUserRoleId: advDashUserRoleId,
            bidDashboardUserRoleId: bidDashUserRoleId,
            pubDashboardUserRoleId: pubDashUserRoleId,

            dashboard_enabled: resultData.dashboard_enabled,
            dashboard_max_days: resultData.dashboard_max_days,
            supply_dashboard_enabled: resultData.supply_dashboard_enabled,
            supply_dashboard_max_days: resultData.supply_dashboard_max_days,
            supply_dashboard_accounts:
              resultData.supply_dashboard_accounts != "" &&
              resultData.supply_dashboard_accounts != null
                ? resultData.supply_dashboard_accounts.split(",")
                : "",
            supply_dashboard_show_prices:
              resultData.supply_dashboard_show_prices,
            supply_dashboard_price_percentage:
              resultData.supply_dashboard_price_percentage,
            singleSignonCode: resultData.single_signon_code,
            reference_user_id: resultData.reference_user_id,
            geointel_enabled:
              resultData.geointel_enabled != null
                ? resultData.geointel_enabled
                : "0",
          };
          //console.log('userData', userData)
          state.userDetails = userData;
        }
        state.loading = false;
      })
      .addCase(GetUserDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(GetRolesListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetRolesListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          state.rolesList = action.payload.data.results[0];
          let dashboardUserRoles = action.payload.data.results[1];
          state.transferUserList = action.payload.data.results[2];

          let advDashboardUserRoles = [];
          let bidDashboardUserRoles = [];
          let pubDashboardUserRoles = [];

          dashboardUserRoles.map((info) => {
            if (info.profile == "advertiser") {
              advDashboardUserRoles.push(info);
            } else if (info.profile == "bidder") {
              bidDashboardUserRoles.push(info);
            } else if (info.profile == "publisher") {
              pubDashboardUserRoles.push(info);
            }
          });
          state.dashboardUserRoleList = {
            advertiser: advDashboardUserRoles,
            bidder: bidDashboardUserRoles,
            publisher: pubDashboardUserRoles,
          };

          state.userFlag = true;
        }
        state.loading = false;
      })
      .addCase(GetRolesListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(CheckUserNameExists.pending, (state) => {
        state.loading = true;
      })
      .addCase(CheckUserNameExists.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          console.log("Inside check username exists");
          //state.rolesList = action.payload.data.results[0];
          //state.userFlag = true;
        }
        state.loading = false;
      })
      .addCase(CheckUserNameExists.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateUserStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateUserStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let userList = state.usersList;
          let userId = action.meta.arg.id;
          let status = action.meta.arg.status;
          userList.map((uinfo) => {
            if (uinfo.id == userId) {
              uinfo.is_active = status;
            }
            return uinfo;
          });
          //userList = userList.filter((item) => item.id !== userId);
          state.usersList = userList;
        }
        state.loading = false;
      })
      .addCase(UpdateUserStatusThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getDashboardUserRoleInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardUserRoleInfo.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          // state.dashboardUserRoleInfo = action.payload.data?.results;
        }
        state.loading = false;
      })
      .addCase(getDashboardUserRoleInfo.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      });
  },
});
const { actions, reducer } = User;
// Extract and export each action creator by name
export const {
  resetUserForm,
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
  updateUserFiltersFormValues,
  updateUserFilters,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
